import React from 'react';

import { Col } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';

import type { AccordionItem } from './Accordion';
import { Accordion } from './Accordion';
import { ContentWrapper } from './ContentWrapper';

interface IFaqSectionProps {
  faqs: AccordionItem[];
}

const FaqSection: React.FC<IFaqSectionProps> = ({ faqs }) => {
  return (
    <ContentWrapper>
      <Col className="w-full gap-7 p-7">
        <Text as="h3" className="text-subheader-xs">
          FAQs
        </Text>
        <Accordion items={faqs} />
      </Col>
    </ContentWrapper>
  );
};

export default FaqSection;
